import { useState } from "react";
import { useDispatch } from "react-redux";
import { contactUs } from "../slice/fundraisingSlice";
import { toast } from "react-toastify";

import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index";

import FundraisingHeader from "../layout/header";
import FundraisingFooter from '../layout/footer';


const fundraisingOptions = [
    { value: "Facility Capital Campaign", label: "Facility Capital Campaign" },
    { value: "Digital Platform", label: "Digital Platform" },
    { value: "Major Gift", label: "Major Gift" },
    { value: "Naming Opportunity", label: "Naming Opportunity" },
    { value: "Corporate Partnership", label: "Corporate Partnership" },
    { value: "Foundation Funding", label: "Foundation Funding" },
    { value: "Other", label: "Other" },
];

const initialFormData = {
    full_name: "",
    email: "",
    organization: "",
    fundraising_interest: "",
    fundraising_interest_other: "",
    gift_interest_range: "",
    preferred_contact_method: "",
    meeting_requested: "no",
    message: "",
    consent_to_contact: false,
    privacy_notice_acknowledged: false,
};

const CampaignContact = () => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState(initialFormData);
    const [giftMin, setGiftMin] = useState("");
    const [giftMax, setGiftMax] = useState("");
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
        setErrors((prev) => ({
            ...prev,
            [name]: "",
            contact: "",
            gift_interest_range: "",
            fundraising_interest_other: "",
        }));
        setSuccessMessage("");
    };

    const updateGiftRange = (min, max) => {
        setFormData((prev) => ({
            ...prev,
            gift_interest_range: min !== "" || max !== "" ? `${min} - ${max}` : "",
        }));
        setErrors((prev) => ({ ...prev, gift_interest_range: "" }));
        setSuccessMessage("");
    };

    const handleGiftMinChange = (e) => {
        const value = e.target.value;
        setGiftMin(value);
        updateGiftRange(value, giftMax);
    };

    const handleGiftMaxChange = (e) => {
        const value = e.target.value;
        setGiftMax(value);
        updateGiftRange(giftMin, value);
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.full_name.trim()) {
            newErrors.full_name = "Full name is required.";
        } else if (formData.full_name.trim().length < 2) {
            newErrors.full_name = "Please enter a valid full name.";
        }

        const email = formData.email.trim();
        if (!email) {
            newErrors.contact = "Please provide an email address.";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            newErrors.email = "Please enter a valid email address.";
        }

        if (!formData.fundraising_interest) {
            newErrors.fundraising_interest = "Please select an area of fundraising interest.";
        } else if (formData.fundraising_interest === "Other" && !formData.fundraising_interest_other.trim()) {
            newErrors.fundraising_interest_other = "Please provide details for your fundraising interest.";
        }

        if (!formData.consent_to_contact) {
            newErrors.consent_to_contact = "Consent to be contacted is required.";
        }

        if (!formData.privacy_notice_acknowledged) {
            newErrors.privacy_notice_acknowledged = "Please acknowledge the privacy notice.";
        }

        const min = giftMin === "" ? null : Number(giftMin);
        const max = giftMax === "" ? null : Number(giftMax);

        if ((giftMin !== "" && (!Number.isFinite(min) || min < 0)) || (giftMax !== "" && (!Number.isFinite(max) || max < 0))) {
            newErrors.gift_interest_range = "Gift amounts must be valid, non-negative numbers.";
        } else if (giftMin !== "" && giftMax !== "" && max < min) {
            newErrors.gift_interest_range = "Maximum gift amount must be greater than or equal to the minimum.";
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            const firstError = Object.values(newErrors)[0];
            toast.error(firstError, { position: "top-right", autoClose: 3000, style: { fontSize: "0.85rem" } });
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccessMessage("");
        if (!validateForm()) return;
        setIsSubmitting(true);

        try {
            const payload = {
                ...formData,
                full_name: formData.full_name.trim(),
                email: formData.email.trim(),
                organization: formData.organization.trim(),
                gift_interest_range: formData.gift_interest_range,
                fundraising_interest_other: formData.fundraising_interest_other.trim(),
                message: formData.message.trim(),
                meeting_requested: formData.meeting_requested === "yes" ? 1 : 0,
                consent_to_contact: formData.consent_to_contact ? 1 : 0,
                privacy_notice_acknowledged: formData.privacy_notice_acknowledged ? 1 : 0,
            };

            try {
                const response = await dispatch(contactUs(payload)).unwrap();
                if (response) {
                    toast.success("Message sent successfully", { position: "top-right", autoClose: 2000, style: { fontSize: "0.85rem" } });
                }
            } catch (error) {
                toast.error("Failed to contact", { position: "top-right", autoClose: 2000, style: { fontSize: "0.85rem" } });
            }

            setFormData(initialFormData);
            setGiftMin("");
            setGiftMax("");
        } catch (error) {
            setErrors({ submit: error.message || "Something went wrong. Please try again." });
        } finally {
            setIsSubmitting(false);
        }
    };

    // Reusable Input Style
    const inputStyle = {
        backgroundColor: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: '12px',
        padding: '0.75rem 1rem',
        fontSize: '1rem',
        boxShadow: 'none'
    };

    const labelStyle = {
        color: '#1e293b',
        fontWeight: 600,
        fontSize: '0.9rem',
        marginBottom: '0.5rem'
    };

    return (
        <>
            <FundraisingHeader />

            <main className="overflow-hidden" style={{ marginTop: "-20px" }}>

                {/* ================= HERO SECTION (Matching Reference) ================= */}
                                {/* ================= HERO SECTION (Split Layout) ================= */}
                <section className="position-relative overflow-hidden" style={{ backgroundColor: '#fdfaf4' }}>
                    <div className="container-fluid px-0">
                        <div className="row g-0 align-items-stretch" style={{ minHeight: '85vh' }}>
                            
                            {/* LEFT COLUMN - Text Content on Solid Background */}
                            <div className="col-lg-6 d-flex flex-column justify-content-between p-4 p-md-5 position-relative" style={{ zIndex: 2 }}>
                                <div className="ps-lg-4 pt-lg-4">
                                    

                                    {/* Headline */}
                                    <h1
                                        className="fw-bold mb-4"
                                        style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: 'clamp(2.5rem, 4.5vw, 4rem)', lineHeight: 1.1, color: '#0f172a' }}
                                    >
                                        Contact <br />
                                        the Campaign Team.
                                    </h1>

                                    <p className="lh-lg mb-5" style={{ color: '#4b5563', fontSize: '1.15rem', maxWidth: '480px', fontWeight: 500 }}>
                                        We'd love to hear from you. Reach out to learn more about the campaign, partnership opportunities, naming options, or how to get involved.
                                    </p>
                                </div>

                                {/* Bottom 3 Cards - Moved inside the left column for better layout on desktop */}
                                <div className="row g-3 ps-lg-4 pb-lg-4 mt-auto">
    {/* Card 1: Email Us */}
    <div className="col-md-4">
        <div 
            className="rounded-4 p-4 text-center h-100 shadow-sm border-0"
            style={{ 
                transition: 'all 0.3s ease', 
                cursor: 'pointer',
                backgroundColor: '#ffffff' // Default white
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.02)';
                e.currentTarget.style.boxShadow = '0 20px 40px -10px rgba(15,23,42,0.2)';
                e.currentTarget.style.backgroundColor = '#1e293b'; // Theme Navy Blue
                
                const title = e.currentTarget.querySelector('.card-title');
                if(title) title.style.color = '#ffffff';

                const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                if(iconWrap) {
                    iconWrap.style.background = 'rgba(255,255,255,0.1)';
                    iconWrap.style.color = '#fbbf24';
                }
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)';
                e.currentTarget.style.backgroundColor = '#ffffff';
                
                const title = e.currentTarget.querySelector('.card-title');
                if(title) title.style.color = '#1e293b';

                const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                if(iconWrap) {
                    iconWrap.style.background = 'rgba(251,191,36,0.15)';
                    iconWrap.style.color = '#d97706';
                }
            }}
        >
            <div 
                className="icon-wrapper d-flex align-items-center justify-content-center mx-auto rounded-circle mb-3" 
                style={{ width: 50, height: 50, background: 'rgba(251,191,36,0.15)', color: '#d97706', transition: 'all 0.3s ease' }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
            </div>
            <h6 className="card-title fw-bold mb-1" style={{ color: '#1e293b', fontFamily: '"Playfair Display", serif', transition: 'color 0.3s ease' }}>Email Us</h6>
        </div>
    </div>

    {/* Card 2: Schedule a Call */}
    <div className="col-md-4">
        <div 
            className="rounded-4 p-4 text-center h-100 shadow-sm border-0"
            style={{ 
                transition: 'all 0.3s ease', 
                cursor: 'pointer',
                backgroundColor: '#ffffff' // Default white
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.02)';
                e.currentTarget.style.boxShadow = '0 20px 40px -10px rgba(15,23,42,0.2)';
                e.currentTarget.style.backgroundColor = '#1e293b'; // Theme Navy Blue
                
                const title = e.currentTarget.querySelector('.card-title');
                if(title) title.style.color = '#ffffff';

                const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                if(iconWrap) {
                    iconWrap.style.background = 'rgba(255,255,255,0.1)';
                    iconWrap.style.color = '#fbbf24';
                }
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)';
                e.currentTarget.style.backgroundColor = '#ffffff';
                
                const title = e.currentTarget.querySelector('.card-title');
                if(title) title.style.color = '#1e293b';

                const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                if(iconWrap) {
                    iconWrap.style.background = 'rgba(251,191,36,0.15)';
                    iconWrap.style.color = '#d97706';
                }
            }}
        >
            <div 
                className="icon-wrapper d-flex align-items-center justify-content-center mx-auto rounded-circle mb-3" 
                style={{ width: 50, height: 50, background: 'rgba(251,191,36,0.15)', color: '#d97706', transition: 'all 0.3s ease' }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
            </div>
            <h6 className="card-title fw-bold mb-1" style={{ color: '#1e293b', fontFamily: '"Playfair Display", serif', transition: 'color 0.3s ease' }}>Schedule a Call</h6>
        </div>
    </div>

    {/* Card 3: Request a Meeting */}
    <div className="col-md-4">
        <div 
            className="rounded-4 p-4 text-center h-100 shadow-sm border-0"
            style={{ 
                transition: 'all 0.3s ease', 
                cursor: 'pointer',
                backgroundColor: '#ffffff' // Default white
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.02)';
                e.currentTarget.style.boxShadow = '0 20px 40px -10px rgba(15,23,42,0.2)';
                e.currentTarget.style.backgroundColor = '#1e293b'; // Theme Navy Blue
                
                const title = e.currentTarget.querySelector('.card-title');
                if(title) title.style.color = '#ffffff';

                const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                if(iconWrap) {
                    iconWrap.style.background = 'rgba(255,255,255,0.1)';
                    iconWrap.style.color = '#fbbf24';
                }
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)';
                e.currentTarget.style.backgroundColor = '#ffffff';
                
                const title = e.currentTarget.querySelector('.card-title');
                if(title) title.style.color = '#1e293b';

                const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                if(iconWrap) {
                    iconWrap.style.background = 'rgba(251,191,36,0.15)';
                    iconWrap.style.color = '#d97706';
                }
            }}
        >
            <div 
                className="icon-wrapper d-flex align-items-center justify-content-center mx-auto rounded-circle mb-3" 
                style={{ width: 50, height: 50, background: 'rgba(251,191,36,0.15)', color: '#d97706', transition: 'all 0.3s ease' }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
            </div>
            <h6 className="card-title fw-bold mb-1" style={{ color: '#1e293b', fontFamily: '"Playfair Display", serif', transition: 'color 0.3s ease' }}>Request a Meeting</h6>
        </div>
    </div>
</div>
                            </div>

                            {/* RIGHT COLUMN - Contained Image */}
                            <div className="col-lg-6 d-none d-lg-block position-relative p-0">
                                <img
                                    src="/assets/images/fundraising/07_contact_campaign_team_background.jpg"
                                    alt="Contact the campaign team"
                                    className="w-100 h-100 position-absolute top-0 start-0"
                                    style={{ objectFit: 'cover', objectPosition: 'center left' }}
                                />
                            </div>

                        </div>
                    </div>
                </section>

                {/* ================= FORM SECTION ================= */}
                <section className="py-5" style={{ background: '#fdfaf4', paddingTop: '5rem', paddingBottom: '6rem' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-9">
                                
                                {/* Form Card */}
                                <div 
                                    className="card border-0 rounded-4 shadow-lg p-4 p-md-5"
                                    style={{ background: '#ffffff', borderTop: '4px solid #fbbf24 !important' }}
                                >
                                    <div className="mb-5 text-center">
                                        <h2
                                            className="fw-bold mb-2"
                                            style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: '2rem', color: '#0f172a' }}
                                        >
                                            Send Us a Message
                                        </h2>
                                        <p className="mb-0" style={{ color: '#64748b' }}>
                                            Fill out the form below and our team will get back to you shortly.
                                        </p>
                                    </div>

                                    <form onSubmit={handleSubmit} noValidate>
                                        <div className="row g-4">
                                            
                                            {/* Full Name */}
                                            <div className="col-md-6">
                                                <label htmlFor="full_name" style={labelStyle}>Full Name <span className="text-danger">*</span></label>
                                                <input
                                                    id="full_name"
                                                    type="text"
                                                    name="full_name"
                                                    className={`form-control ${errors.full_name ? "is-invalid" : ""}`}
                                                    style={inputStyle}
                                                    placeholder="Enter your full name"
                                                    value={formData.full_name}
                                                    onChange={handleChange}
                                                    autoComplete="name"
                                                    maxLength={150}
                                                    required
                                                />
                                                {errors.full_name && <div className="invalid-feedback">{errors.full_name}</div>}
                                            </div>

                                            {/* Email */}
                                            <div className="col-md-6">
                                                <label htmlFor="email" style={labelStyle}>Email <span className="text-danger">*</span></label>
                                                <input
                                                    id="email"
                                                    type="email"
                                                    name="email"
                                                    className={`form-control ${errors.email || errors.contact ? "is-invalid" : ""}`}
                                                    style={inputStyle}
                                                    placeholder="Enter your email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    autoComplete="email"
                                                    maxLength={254}
                                                />
                                                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                                {errors.contact && <div className="invalid-feedback mt-1">{errors.contact}</div>}
                                            </div>

                                            {/* Organization */}
                                            <div className="col-md-6">
                                                <label htmlFor="organization" style={labelStyle}>Organization (Optional)</label>
                                                <input
                                                    id="organization"
                                                    type="text"
                                                    name="organization"
                                                    className="form-control"
                                                    style={inputStyle}
                                                    placeholder="Enter organization name"
                                                    value={formData.organization}
                                                    onChange={handleChange}
                                                    autoComplete="organization"
                                                    maxLength={200}
                                                />
                                            </div>

                                            {/* Fundraising Interest */}
                                            <div className="col-md-6">
                                                <label htmlFor="fundraising_interest" style={labelStyle}>Area of Interest <span className="text-danger">*</span></label>
                                                <select
                                                    id="fundraising_interest"
                                                    name="fundraising_interest"
                                                    className={`form-select ${errors.fundraising_interest ? "is-invalid" : ""}`}
                                                    style={inputStyle}
                                                    value={formData.fundraising_interest}
                                                    onChange={handleChange}
                                                    required
                                                >
                                                    <option value="">Select fundraising interest</option>
                                                    {fundraisingOptions.map((option) => (
                                                        <option key={option.value} value={option.value}>{option.label}</option>
                                                    ))}
                                                </select>
                                                {errors.fundraising_interest && <div className="invalid-feedback">{errors.fundraising_interest}</div>}
                                            </div>

                                            {/* Conditional Textarea for "Other" */}
                                            {formData.fundraising_interest === "Other" && (
                                                <div className="col-12">
                                                    <label htmlFor="fundraising_interest_other" style={labelStyle}>Please specify <span className="text-danger">*</span></label>
                                                    <textarea
                                                        id="fundraising_interest_other"
                                                        name="fundraising_interest_other"
                                                        rows="3"
                                                        className={`form-control ${errors.fundraising_interest_other ? "is-invalid" : ""}`}
                                                        style={inputStyle}
                                                        placeholder="Enter details about your fundraising interest..."
                                                        value={formData.fundraising_interest_other}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                    {errors.fundraising_interest_other && <div className="invalid-feedback">{errors.fundraising_interest_other}</div>}
                                                </div>
                                            )}

                                            {/* Gift Range */}
                                            <div className="col-md-6">
                                                <label style={labelStyle}>Gift-Interest Range (Optional)</label>
                                                <div className="row g-2">
                                                    <div className="col-6">
                                                        <input
                                                            type="number"
                                                            className={`form-control ${errors.gift_interest_range ? "is-invalid" : ""}`}
                                                            style={inputStyle}
                                                            placeholder="Min"
                                                            min="0"
                                                            step="any"
                                                            value={giftMin}
                                                            onChange={handleGiftMinChange}
                                                        />
                                                    </div>
                                                    <div className="col-6">
                                                        <input
                                                            type="number"
                                                            className={`form-control ${errors.gift_interest_range ? "is-invalid" : ""}`}
                                                            style={inputStyle}
                                                            placeholder="Max"
                                                            min="0"
                                                            step="any"
                                                            value={giftMax}
                                                            onChange={handleGiftMaxChange}
                                                        />
                                                    </div>
                                                </div>
                                                {errors.gift_interest_range && <div className="text-danger small mt-1">{errors.gift_interest_range}</div>}
                                            </div>

                                            {/* Preferred Contact Method */}
                                            <div className="col-md-6">
                                                <label htmlFor="preferred_contact_method" style={labelStyle}>Preferred Contact Method</label>
                                                <select
                                                    id="preferred_contact_method"
                                                    name="preferred_contact_method"
                                                    className="form-select"
                                                    style={inputStyle}
                                                    value={formData.preferred_contact_method}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">No preference</option>
                                                    <option value="email">Email</option>
                                                    <option value="phone">Phone</option>
                                                    <option value="either">Either Email or Phone</option>
                                                </select>
                                            </div>

                                            {/* Meeting Request */}
                                            <div className="col-12 mt-4">
                                                <label style={labelStyle} className="d-block mb-3">Would you like to request a meeting?</label>
                                                <div className="d-flex gap-3">
                                                    <div 
                                                        className="px-4 py-2 rounded-pill cursor-pointer fw-semibold"
                                                        style={{ 
                                                            background: formData.meeting_requested === "no" ? '#1e293b' : '#f8fafc',
                                                            color: formData.meeting_requested === "no" ? '#ffffff' : '#64748b',
                                                            border: '1px solid #e2e8f0',
                                                            cursor: 'pointer',
                                                            transition: 'all 0.2s'
                                                        }}
                                                        onClick={() => setFormData(prev => ({ ...prev, meeting_requested: "no" }))}
                                                    >
                                                        No
                                                    </div>
                                                    <div 
                                                        className="px-4 py-2 rounded-pill cursor-pointer fw-semibold"
                                                        style={{ 
                                                            background: formData.meeting_requested === "yes" ? '#1e293b' : '#f8fafc',
                                                            color: formData.meeting_requested === "yes" ? '#ffffff' : '#64748b',
                                                            border: '1px solid #e2e8f0',
                                                            cursor: 'pointer',
                                                            transition: 'all 0.2s'
                                                        }}
                                                        onClick={() => setFormData(prev => ({ ...prev, meeting_requested: "yes" }))}
                                                    >
                                                        Yes
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Message */}
                                            <div className="col-12 mt-4">
                                                <label htmlFor="message" style={labelStyle}>Message (Optional)</label>
                                                <textarea
                                                    id="message"
                                                    name="message"
                                                    className="form-control"
                                                    style={inputStyle}
                                                    rows="4"
                                                    placeholder="Tell us how we can help..."
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                    maxLength={3000}
                                                />
                                                <div className="text-end mt-1">
                                                    <small className="text-muted" style={{ fontSize: '0.75rem' }}>
                                                        {formData.message.length}/3000 characters
                                                    </small>
                                                </div>
                                            </div>

                                            {/* Checkboxes */}
                                            <div className="col-12 mt-4">
                                                <div className="form-check mb-3">
                                                    <input
                                                        id="consent_to_contact"
                                                        type="checkbox"
                                                        name="consent_to_contact"
                                                        className={`form-check-input ${errors.consent_to_contact ? "is-invalid" : ""}`}
                                                        checked={formData.consent_to_contact}
                                                        onChange={handleChange}
                                                        required
                                                        style={{ cursor: 'pointer', width: '1.2rem', height: '1.2rem', marginTop: '0.15rem' }}
                                                    />
                                                    <label htmlFor="consent_to_contact" className="form-check-label ms-2" style={{ color: '#4b5563', fontSize: '0.95rem', cursor: 'pointer' }}>
                                                        I consent to being contacted regarding my fundraising interest. <span className="text-danger">*</span>
                                                    </label>
                                                    {errors.consent_to_contact && <div className="text-danger small mt-1">{errors.consent_to_contact}</div>}
                                                </div>

                                                <div className="form-check">
                                                    <input
                                                        id="privacy_notice_acknowledged"
                                                        type="checkbox"
                                                        name="privacy_notice_acknowledged"
                                                        className={`form-check-input ${errors.privacy_notice_acknowledged ? "is-invalid" : ""}`}
                                                        checked={formData.privacy_notice_acknowledged}
                                                        onChange={handleChange}
                                                        required
                                                        style={{ cursor: 'pointer', width: '1.2rem', height: '1.2rem', marginTop: '0.15rem' }}
                                                    />
                                                    <label htmlFor="privacy_notice_acknowledged" className="form-check-label ms-2" style={{ color: '#4b5563', fontSize: '0.95rem', cursor: 'pointer' }}>
                                                        I acknowledge that I have read the privacy notice. <span className="text-danger">*</span>
                                                    </label>
                                                    {errors.privacy_notice_acknowledged && <div className="text-danger small mt-1">{errors.privacy_notice_acknowledged}</div>}
                                                </div>
                                            </div>

                                            {/* Alerts */}
                                            {errors.submit && (
                                                <div className="col-12 mt-3">
                                                    <div className="alert alert-danger rounded-3 border-0" role="alert">
                                                        {errors.submit}
                                                    </div>
                                                </div>
                                            )}

                                            {successMessage && (
                                                <div className="col-12 mt-3">
                                                    <div className="alert alert-success rounded-3 border-0" role="status">
                                                        {successMessage}
                                                    </div>
                                                </div>
                                            )}

                                            {/* Submit Button */}
                                            <div className="col-12 mt-5">
                                                <button
                                                    type="submit"
                                                    className="btn w-100 fw-bold rounded-pill py-3 border-0 shadow"
                                                    disabled={isSubmitting}
                                                    style={{ 
                                                        background: '#1e293b', 
                                                        color: '#ffffff', 
                                                        fontSize: '1.1rem',
                                                        transition: 'transform 0.2s ease'
                                                    }}
                                                    onMouseEnter={(e) => { if(!isSubmitting) e.currentTarget.style.transform = 'translateY(-2px)' }}
                                                    onMouseLeave={(e) => { if(!isSubmitting) e.currentTarget.style.transform = 'translateY(0)' }}
                                                >
                                                    {isSubmitting ? "Submitting..." : "Send Message"}
                                                </button>
                                            </div>
                                            
                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

            </main>

            <FundraisingFooter />
        </>
    );
};

export default CampaignContact;